import { render } from "./DeliveryTabInfo.vue?vue&type=template&id=540892a6"
import script from "./DeliveryTabInfo.vue?vue&type=script&lang=js"
export * from "./DeliveryTabInfo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__